import { Component, OnInit, ElementRef, ViewChild, Injectable,TemplateRef} from '@angular/core';
import { NgbDateStruct, NgbCalendar, NgbDatepicker, NgbDate, NgbDatepickerConfig, NgbDateParserFormatter, NgbModule,NgbAlertModule,NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder,FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import $ from 'jquery';
import { ApiService } from '../services/api.service';
import { CommonEventService } from '../services/common-event.service';
// import '@angular/localize/init';

import { DataTableDirective,DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AgGridAngular} from 'ag-grid-angular';
import {ColDef,ColGroupDef ,GridApi,GridReadyEvent,ValueGetterParams, ModuleRegistry, ClientSideRowModelModule,PaginationModule,CsvExportModule,ValidationModule,CellStyleModule ,RowAutoHeightModule } from 'ag-grid-community';




import { CommonModule } from '@angular/common';
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  PaginationModule,
  CsvExportModule,
   ValidationModule,
   CellStyleModule,
   RowAutoHeightModule 
]);




@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  format(date: NgbDateStruct | null): string {
    return date ? `${this.pad(date.month)}/${this.pad(date.day)}/${date.year}` : '';
  }
  pad(n: number) {
    return n < 10 ? `0${n}` : `${n}`;
  }
  parse(value: string): NgbDateStruct | null {
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length === 3) {
        return { month: +dateParts[0], day: +dateParts[1], year: +dateParts[2] };
      }
    }
    return null;
   
  }
  
}
@Component({
    selector: 'app-admin-dashboard',
    templateUrl: './admin-dashboard.component.html',
    styleUrls: ['./admin-dashboard.component.css'],
    providers: [
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ],
    imports: [ FormsModule,ReactiveFormsModule, CommonModule,DataTablesModule,NgbDatepickerModule, AgGridAngular ],
    standalone: true
})

export class AdminDashboardComponent implements OnInit {
  
  adminSearchData:any={};
  selectFilterOption:any;
  model: NgbDateStruct | undefined ;
  closeResult: string = '';
  issuesList: any = '';
  extractedList:any='';
  defaultList:any='';
  updatedList:any='';
  dashBoardArray:any=[];
  emailIdToSearch:any='';
  orderPlacedToSearch:any = '';
  quotePlacedToSearch:any = '';
  productTypeToSearch:any='';
  toDateToSearch:any ='';
  fromDateToSearch:any='';
  searchField : boolean = true;
  paginatedItems: any = [];
  itemsPerPage = 15;
  currentPage = 1;
  totalPages = 0;
  maxVisiblePages= 10;
  today:any;
  maxDate:any;
  summaryColLabels:any;
  summaryRowData:any;
  isSummaryDataHasOlder:boolean=false;
  summaryColData:any;
  filteredSummaryColData:any;
  matchingDashboardDataArray:any=[];
  monthsArray=["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  loginCheck:boolean=false;
  loinEmail:any;
  loginPwd:any;
  customParametersList:any;
  sheetTitle = 'Dashboard Details';
  showGrid = false;
  rowData: any[] = [];
  exportFileName : any ='';
  columnDefs: Array<ColDef | ColGroupDef> = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: false,
    resizable: false,
    autoHeight: true,
    // cellStyle: {
    //   textAlign: 'center',
    //   display: 'flex',
    //   alignItems: 'center',
    //   justifyContent: 'center'
    // },
    cellClass: 'ag-center-cell'
  };
  pageVisitCellStyle = {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    lineHeight: '20px',
    textAlign: 'center',
    overflow: 'visible'
  };
  dtOptionsSummary : any = {};
  dtTriggerSummary: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, {static: false}) dtSummary!: DataTableDirective;

  gridApi!: GridApi;

  onGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
  }

  
  // dtOptionsDetails : any = {};
  dtTriggerDetails: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, {static: false}) dtDetails!: DataTableDirective;

  @ViewChild('uploadedFileIssues')
  uploadedFileIssuesTemplate!: TemplateRef<any>;
  @ViewChild('listOfSpecification')
  listOfSpecificationTemplate!: TemplateRef<any>;
  @ViewChild('customSpecification')
  listOfCustomSpecificationsTemplate!: TemplateRef<any>;


  constructor(
    public ngb : NgbModule,
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    public apiService : ApiService,
    public ngbDatepickerModule : NgbDatepickerModule,
    public ngbAlertModule : NgbAlertModule,
    public formsModule : FormsModule,
    public commonService : CommonEventService
  ){
  }
  

  ngOnInit(): void {

          this.dtOptionsSummary = {
            dom: 'Brt',
            scrollX: true,
            paging: false,
            searching: false,
            info: false,
            lengthChange: true,
            ordering:false,
            order: [],
            buttons: [
              {
                extend: 'excelHtml5',
                title: 'Summery Data',
                text: 'Export to Excel',
                exportOptions: {
                  modifier: { page: 'all', search: 'applied', order: 'applied' }
                }

              }
            ]
          };


          // this.dtOptionsDetails = {
          //   dom: 'Brtp',
          //   scrollX: true,
          //   paging: true,
          //   pageLength :15,
          //   searching: false,
          //   info: false,
          //   lengthChange: true,
          //   ordering:false,
          //   order: [],
          //   buttons: [
          //     {
          //       extend: 'excelHtml5',
          //       title: this.sheetTitle,
          //       text: 'Export to Excel',
          //       exportOptions: {
          //         modifier: { page: 'all', search: 'applied', order: 'applied' }
          //       }

          //     }
          //   ]
          // };
  }

  
  ngOnDestroy(): void {
    // this.dtTriggerDetails.next()
    this.dtTriggerDetails.complete();
    this.dtTriggerSummary.complete();
  }
  
  ngAfterViewInit(): void {
    this.setupPagination();
  }

  inItDataLoad(){
    // this.adminSearchData.searchByOptionVal = "0";
    var customsToDate, customFromDate ='';
    // this.callTogetAdminDashboardDatas('','','',1,'');
    this.selectFilterOption = 'date';
    this.adminSearchData.searchByOptionVal = 'date';
    //OFP-3689
    const pstDateNow = this.getPstDate();
     // Today's date (PST)
    this.toDateToSearch = {
      year: pstDateNow.getFullYear(),
      month: pstDateNow.getMonth() + 1,
      day: pstDateNow.getDate()
    };
    // 7 days back (PST)
    const fromSevenDays = new Date(pstDateNow);
    fromSevenDays.setDate(fromSevenDays.getDate() - 6);
    this.fromDateToSearch = {
      year: fromSevenDays.getFullYear(),
      month: fromSevenDays.getMonth() + 1,
      day: fromSevenDays.getDate()
    };
    this.maxDate = { 
      year: pstDateNow.getFullYear(), 
      month: pstDateNow.getMonth() + 1, 
      day: pstDateNow.getDate() 
    };
    if (this.fromDateToSearch) {
      // Format the date as mm/dd/yyyy
      const day = this.fromDateToSearch.day < 10 ? '0' + this.fromDateToSearch.day : this.fromDateToSearch.day;
      const month = this.fromDateToSearch.month < 10 ? '0' + this.fromDateToSearch.month : this.fromDateToSearch.month;
      customFromDate = `${this.fromDateToSearch.year}-${month}-${day}`;
    }
    if(this.toDateToSearch){
      const day = this.toDateToSearch.day < 10 ? '0' + this.toDateToSearch.day : this.toDateToSearch.day;
      const month = this.toDateToSearch.month < 10 ? '0' + this.toDateToSearch.month : this.toDateToSearch.month;
      customsToDate = `${this.toDateToSearch.year}-${month}-${day}`;
    }
    this.callToGetDashboardSummaryData(customFromDate,customsToDate);
    //this.clearSearchData();
  }

  getPstDate(){
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    const parts = formatter.formatToParts(new Date());

    const get = (type: string) =>
      Number(parts.find(p => p.type === type)?.value);

    return new Date(
      get('year'),
      get('month') - 1,
      get('day'),
      get('hour'),
      get('minute'),
      get('second')
    );
  }

  adminLoginForm = new FormGroup({
      loginEmailId: new FormControl('', [Validators.required, Validators.minLength(1),Validators.maxLength(100)]),
      loginPassword: new FormControl('', [Validators.required, Validators.minLength(1),Validators.maxLength(100)]),
  });

  login_validation_messages = {
    'loginEmailId': [
      { type: 'required', message: 'User name is required.' },
      { type: 'minlength', message: 'User name must be at least 1 characters long.' },
      { type: 'maxlength', message: 'User name cannot be more than 100 characters long.' },
      // { type: 'pattern', message: 'Your first name must contain only letters.' }
    ],
    'loginPassword': [
      { type: 'required', message: 'Password is required.' },
      { type: 'minlength', message: 'Password must be at least 1 characters long.' },
      { type: 'maxlength', message: 'Password cannot be more than 100 characters long.' },
    ],
  }

  loginClick(){
    var loginCreds = {
      "loginId": this.loinEmail,
      "password": this.loginPwd
    }
    this.apiService.adminDashBoardLogin(loginCreds).subscribe((data: any)=>{
      if((data != null || data != '') && (data.userId != '' || data.userId != null)){
        this.loginCheck = true;
        this.inItDataLoad();
      }else{
        this.loginCheck = false;
      }
    },error =>{
      this.loginCheck = false;
      console.log('Error in Login', error);
      this.alertCall('Alert!!',"Invalid Username or Password");   
    })
  }
  
  selectByFilter(event:any){
    this.selectFilterOption = this.adminSearchData.searchByOptionVal == "date" ? "date" : this.adminSearchData.searchByOptionVal == "email" ? "emailId" : this.adminSearchData.searchByOptionVal == "productType" ? "productType" : '';
    //On change of filter option clear the old search data
    this.emailIdToSearch = '';
    this.productTypeToSearch = '';
    // this.fromDateToSearch = '';
    // this.toDateToSearch = '';
  }
  alertCall(title:any,message:any){
    Swal.fire({
      toast: false,
      showConfirmButton: true,
      showCancelButton: false,
      showCloseButton: true,
       allowOutsideClick: false,
      title:title,
      html:message,
      confirmButtonText: 'Ok'
    }).then((result) => {
      this.clearSearchData();
    });
  }
  searchForData(selectedPageNum:any){
    this.showGrid = false;
    if(this.selectFilterOption == 'emailId'){
      if(this.emailIdToSearch == ''){
        this.commonService.showtoast('Please enter Email Id.','warning');
      }else{
        this.callTogetAdminDashboardDatas('email',this.emailIdToSearch,'',selectedPageNum,'');
      }
    }else if(this.selectFilterOption == 'productType'){
      if(this.productTypeToSearch == ''){
        this.commonService.showtoast('Please enter the data.','warning');
      }else{
        this.callTogetAdminDashboardDatas('product',this.productTypeToSearch,'',selectedPageNum,'');
      }
    }else if(this.selectFilterOption == 'date'){
      var fromDate, customFromDate= '';
      var toDate, customsToDate = '';
      if (this.fromDateToSearch) {
        // Format the date as mm/dd/yyyy
        const day = this.fromDateToSearch.day < 10 ? '0' + this.fromDateToSearch.day : this.fromDateToSearch.day;
        const month = this.fromDateToSearch.month < 10 ? '0' + this.fromDateToSearch.month : this.fromDateToSearch.month;
        fromDate = `${month}/${day}/${this.fromDateToSearch.year}`;
        customFromDate = `${this.fromDateToSearch.year}-${month}-${day}`;
      }
      if(this.toDateToSearch){
        const day = this.toDateToSearch.day < 10 ? '0' + this.toDateToSearch.day : this.toDateToSearch.day;
        const month = this.toDateToSearch.month < 10 ? '0' + this.toDateToSearch.month : this.toDateToSearch.month;
        toDate = `${month}/${day}/${this.toDateToSearch.year}`;
        customsToDate = `${this.toDateToSearch.year}-${month}-${day}`;
      }
      if(this.fromDateToSearch == ''){
        this.commonService.showtoast('Please enter the from date.','warning');
      }else{
        // this.callTogetAdminDashboardDatas('date',fromDate,toDate,selectedPageNum,'');
        this.callToGetDashboardSummaryData(customFromDate,customsToDate);
      }
    }
  }
  clearSearchData(){
    this.selectFilterOption = '';
    this.adminSearchData.searchByOptionVal = '0';
    this.quotePlacedToSearch = '';
    this.orderPlacedToSearch = '';
    this.emailIdToSearch = '';
    this.productTypeToSearch = '';
    this.paginatedItems=''
    this.showGrid = false;
    // this.callTogetAdminDashboardDatas('','','',1,'');
  }
  openListOfSpecification(content:any,extractedData:any,defaultData:any,updatedData:any){
    this.extractedList = extractedData;
    this.defaultList = defaultData;
    this.updatedList = updatedData;
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  openListOfCustomSpecifications(content:any,customParameters:any){
    this.customParametersList = customParameters;
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  callToGetDashboardSummaryData(fromDate:any,toDate:any){
    this.paginatedItems = '';
    this.commonService.loadingShow();
    this.summaryRowData='';
    this.summaryColLabels='';
    this.summaryColData='';
    this.apiService.getDashboardSummaryData(fromDate,toDate).subscribe((data:any)=>{
      this.commonService.loadingHide();
      console.log("data sum",data);
      this.summaryColData=data.columns;
      this.isSummaryDataHasOlder = data.columns[0].kind == 'OLDER' ? true:false;
      if(this.isSummaryDataHasOlder){
        this.filteredSummaryColData = data.columns.filter((item:any)=> item.kind === 'DAY');
        var yearVal, monthVal = '';
        for(let dataIndex in this.filteredSummaryColData){
          let yearVal,dayVal,monthVal,mmName = '';
          yearVal = this.filteredSummaryColData[dataIndex].date.split('-')[0];
          monthVal = this.filteredSummaryColData[dataIndex].date.split('-')[1];
          dayVal = this.filteredSummaryColData[dataIndex].date.split('-')[2];
          mmName = this.getMonthName(monthVal);
          this.filteredSummaryColData[dataIndex].dateValue = dayVal + ' '+ mmName+ ' '+ yearVal;

        }
      }else{
        var yearVal, monthVal = '';
        for(let dataIndex in data.columns){
          let yearVal,dayVal,monthVal,mmName = '';
          yearVal = data.columns[dataIndex].date.split('-')[0];
          monthVal = data.columns[dataIndex].date.split('-')[1];
          dayVal = data.columns[dataIndex].date.split('-')[2];
          mmName = this.getMonthName(monthVal);
          data.columns[dataIndex].dateValue = dayVal + ' '+ mmName+ ' '+ yearVal;

        }
        this.summaryColLabels=data.columns;
      }
      
      if (!this.dtTriggerSummary || this.dtTriggerSummary.closed) {
        this.dtTriggerSummary = new Subject<any>();
      }

      this.summaryRowData = data.rows;
      
      setTimeout(() => {
        if(!this.dtTriggerSummary.closed) this.dtTriggerSummary.next(this.dtOptionsSummary)
      },0);
    });
  }
  

  getMonthName(monthNum:any){
    return this.monthsArray[monthNum - 1];
  }
  onSummaryDataClick(summaryColName:any,count:any,colIndex:any){
    this.exportFileName='';
    this.adminSearchData.searchByOptionVal = '0';
    this.selectFilterOption = 'date';
    let clickedColumnDate=this.summaryColData[colIndex];
    // OFP-4055
    this.exportFileName =clickedColumnDate.kind == 'OLDER'?clickedColumnDate.label:clickedColumnDate.dateValue;
    this.callTogetAdminDashboardDatas('date',clickedColumnDate.fromDate,clickedColumnDate.toDate,'1',summaryColName);
  }
  callTogetAdminDashboardDatas(opt1:any,opt2:any,opt3:any,page:any, summaryColName:any){
    this.commonService.loadingShow();
    this.paginatedItems=''
    this.commonService.commonMainObj.dashboardData = {};
    this.dashBoardArray=[];
    this.totalPages=0;
    this.currentPage = 1;
    this.matchingDashboardDataArray=[];
    this.showGrid = false;
    this.apiService.getDashboardData(opt1,opt2,opt3,page).subscribe((data: any)=>{
      if(data.data == null || data.data == ''){
        this.paginatedItems=''
        this.dashBoardArray=[];
        this.alertCall('Alert!!',"No data found matching the filtered criteria");
      }else{
        this.commonService.commonMainObj.dashboardData = data.data;
        for(let itemIndex in this.commonService.commonMainObj.dashboardData){
          if(summaryColName == 'File Uploads' && this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.designFileName  != ''){
            this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
          }
          if(summaryColName == 'PCB Only Quoted'){
            let pcbQuoteCount = 0;
            if(this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.pageContentAsMap?.PCBFabPricingPage?.pageVisited != undefined && this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.pageContentAsMap?.PCBFabPricingPage?.pageVisited != ''){
              this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
            }
            else if(this.commonService.commonMainObj.dashboardData[itemIndex].childActivities.length != 0){
              for(let childIndex in this.commonService.commonMainObj.dashboardData[itemIndex].childActivities){
                if(this.commonService.commonMainObj.dashboardData[itemIndex].childActivities[childIndex].pageContentAsMap?.PCBFabPricingPage?.pageVisited != undefined && this.commonService.commonMainObj.dashboardData[itemIndex].childActivities[childIndex].pageContentAsMap?.PCBFabPricingPage?.pageVisited !=''){
                  pcbQuoteCount ++;
                }
              }
              if(pcbQuoteCount > 0){
                this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
              }
            }
          }
          if(summaryColName == 'PCB + Assembly Quoted'){
            let pcbAssemblyCount =0;
            if(this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.pageContentAsMap?.AssemblyLabourPricingPage?.pageVisited != undefined && this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.pageContentAsMap?.AssemblyLabourPricingPage?.pageVisited != ''){
              this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
            }
            else if(this.commonService.commonMainObj.dashboardData[itemIndex].childActivities.length != 0){
              for(let childIndex in this.commonService.commonMainObj.dashboardData[itemIndex].childActivities){
                if(this.commonService.commonMainObj.dashboardData[itemIndex].childActivities[childIndex].pageContentAsMap?.AssemblyLabourPricingPage?.pageVisited != undefined && this.commonService.commonMainObj.dashboardData[itemIndex].childActivities[childIndex].pageContentAsMap?.AssemblyLabourPricingPage?.pageVisited !=''){
                  pcbAssemblyCount++;
                }
              }
              if(pcbAssemblyCount > 0){
                this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
              }
            }
          }
          if(summaryColName == 'Quote Saved'){
            let quoteSavedCount = 0;
            if(this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.pageContentAsMap?.ConfirmQuoteRequestPage?.quoteSaved != undefined && this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.pageContentAsMap?.ConfirmQuoteRequestPage?.quoteSaved != ''){
              this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
            }
            else if(this.commonService.commonMainObj.dashboardData[itemIndex].childActivities.length != 0){
              for(let childIndex in this.commonService.commonMainObj.dashboardData[itemIndex].childActivities){
                if(this.commonService.commonMainObj.dashboardData[itemIndex].childActivities[childIndex].pageContentAsMap?.ConfirmQuoteRequestPage?.quoteSaved != undefined && this.commonService.commonMainObj.dashboardData[itemIndex].childActivities[childIndex].pageContentAsMap?.ConfirmQuoteRequestPage?.quoteSaved !=''){
                  quoteSavedCount++;
                }
              }
              if(quoteSavedCount > 0){
                this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
              }
            }
          }
          if(summaryColName == 'Order Placed'){
            let orderPlacedCount = 0;
            if(this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.pageContentAsMap?.ReviewConfirmOrderPage?.orderId != undefined && this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.pageContentAsMap?.ReviewConfirmOrderPage?.orderId != ''){
              this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
            }
            else if(this.commonService.commonMainObj.dashboardData[itemIndex].childActivities.length != 0){
              for(let childIndex in this.commonService.commonMainObj.dashboardData[itemIndex].childActivities){
                if(this.commonService.commonMainObj.dashboardData[itemIndex].childActivities[childIndex].pageContentAsMap?.ReviewConfirmOrderPage?.orderId != undefined && this.commonService.commonMainObj.dashboardData[itemIndex].childActivities[childIndex].pageContentAsMap?.ReviewConfirmOrderPage?.orderId !=''){
                  orderPlacedCount++;
                }
              }
              if(orderPlacedCount > 0){
                this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
              }
            }
          }
          if(summaryColName == 'Custom Quote Request Placed'){
            let customQuoteCount =0;
            if(this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.quoteRequestPlaced != undefined && this.commonService.commonMainObj.dashboardData[itemIndex].parentActivity.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.quoteRequestPlaced != ''){
              this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
            }
            else if(this.commonService.commonMainObj.dashboardData[itemIndex].childActivities.length != 0){
              for(let childIndex in this.commonService.commonMainObj.dashboardData[itemIndex].childActivities){
                if(this.commonService.commonMainObj.dashboardData[itemIndex].childActivities[childIndex].pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.quoteRequestPlaced != undefined && this.commonService.commonMainObj.dashboardData[itemIndex].childActivities[childIndex].pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.quoteRequestPlaced !=''){
                  customQuoteCount++;  
                }
              }
              if(customQuoteCount > 0){
                this.matchingDashboardDataArray.push(this.commonService.commonMainObj.dashboardData[itemIndex]);
              }
            }
          } 
          if(summaryColName == ''){
            this.matchingDashboardDataArray = this.commonService.commonMainObj.dashboardData;
          }   
        }
        //commenting below to remove pagination logic from backend- OFP-1948
        // this.currentPage = parseInt(data.page)+1;
        // let count = ((this.currentPage -1)*15)+1;
        // OFP-3960
        if(opt2 == opt3){
          const [month, day, year] = opt2.split('/');
          const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
          this.matchingDashboardDataArray = this.matchingDashboardDataArray.filter((item:any) => item.parentActivity.activityDate == formattedDate);
        }
        for(let itemIndx in this.matchingDashboardDataArray){
          let count =  parseInt(itemIndx) + 1;
          let childCount:any = 0;
          
          this.matchingDashboardDataArray[itemIndx].parentActivity.index = count;
          this.dashBoardArray.push(this.matchingDashboardDataArray[itemIndx].parentActivity);
          if(this.matchingDashboardDataArray[itemIndx].childActivities.length != 0){
            for(let childItemIndx in this.matchingDashboardDataArray[itemIndx].childActivities){
              if(this.matchingDashboardDataArray[itemIndx].parentActivity.activityId == this.matchingDashboardDataArray[itemIndx].childActivities[childItemIndx].parentActivityId){
                let cn =  parseInt(childItemIndx) + 1;
                childCount = cn;
                this.matchingDashboardDataArray[itemIndx].childActivities[childItemIndx].index=this.matchingDashboardDataArray[itemIndx].parentActivity.index+'.'+cn;
                this.dashBoardArray.push(this.matchingDashboardDataArray[itemIndx].childActivities[childItemIndx]);
              }
            } 
          }    
        }

        if (!this.dtTriggerDetails || this.dtTriggerDetails.closed) {
          this.dtTriggerDetails = new Subject<any>();
        }
        for(let item in this.dashBoardArray){
          for(let page in this.dashBoardArray[item].pageContentAsMap){
            if(this.dashBoardArray[item].pageContentAsMap[page].sessionTotalTimeSpent){
              this.dashBoardArray[item].totalTimeSpent = this.dashBoardArray[item].pageContentAsMap[page].sessionTotalTimeSpent;
            }
          }
        }
        this.paginatedItems = this.dashBoardArray;
        this.rowData = this.paginatedItems;
        this.buildColumns();
        this.showGrid = true;
        setTimeout(() => {
          this.totalPages = Math.ceil(this.dashBoardArray.length / this.itemsPerPage);
          // this.updatePagination();
          //commenting below to remove pagination logic from backend- OFP-1948
          // this.totalPages = Math.ceil(data.totalElements / this.itemsPerPage);
          // this.updatePagination(this.totalPages);
          
          // setTimeout(()=>{
          // },500)
          this.commonService.loadingHide();
        }, 500);
        // setTimeout(() => {
        //   if(!this.dtTriggerDetails.closed) this.dtTriggerDetails.next(this.dtOptionsDetails)
        // },0);
      }
    },error =>{
      console.log('Error in getting dashboard data', error);   
    })
  }
  // OFP-3428 AG-grid migration
  getRowHeight = (params: any) => {
    const colMapping = params.data?.pageContentAsMap.BOMColumnPage?.mapping;
    const designFileLength = params.data?.designFileName?.length;
    let returnHeight=0;
    if (!colMapping && designFileLength < 120) {
      return 120;
    }
    if(designFileLength > 120 || !colMapping){
      returnHeight = 250
    }
    else if(colMapping){
      returnHeight = 350
    }
    return returnHeight;
  };

  buildColumns() {
    this.columnDefs = [
    {
      headerName: 'Sl.No',
      valueFormatter: (params: any) => params.value != null ? params.value.toString() : '',
      field: 'index',
      pinned: 'left',
      width: 80,
      autoHeight: true,
      wrapText: true,
      cellStyle: this.pageVisitCellStyle,
      suppressSpanHeaderHeight: true,
      headerClass: 'hide-empty-header',
    },
    {
      headerName: 'UID',
      field:'activityId',
      pinned: 'left',
      width: 150,
      autoHeight: true,
      wrapText: true,
      cellStyle: this.pageVisitCellStyle,
      suppressSpanHeaderHeight: true,
      headerClass: 'hide-empty-header',
    },
    {
      headerName: 'Email ID',
      pinned: 'left',
      autoHeight: true,
      wrapText: true,
      cellStyle: this.pageVisitCellStyle,
      suppressSpanHeaderHeight: true,
      headerClass: 'hide-empty-header',
      valueGetter: ({ data }: { data: any }) =>
        data?.emailId ||
        data?.pageContentAsMap?.BoardDetailsPage?.emailId ||
        data?.pageContentAsMap?.BOMPreProcessorPage?.emailId ||
        data?.pageContentAsMap?.ComponentProcurementPage?.emailId ||
        '',
        width:160,
    },
    {
      headerName: 'Guest User / Signed-In?',
      suppressSpanHeaderHeight: true,
      headerClass: 'hide-empty-header',
      valueGetter: (params:any) => {
        const guest = params.data?.guestUser;
        if (guest === true) {
          return 'Guest User';
        }
        if (guest != null) {
          return 'Signed-In User';
        }
        return '';
      },
      pinned: 'left',
      width: 120,
      autoHeight: true,
      wrapText: true,
      cellStyle: this.pageVisitCellStyle,
    },
    {
      headerName: 'Source',
      field:'source',
      pinned: 'left',
      width: 100,
      suppressSpanHeaderHeight: true,
      headerClass: 'hide-empty-header',
    },
    {
      headerName: 'Design File',
      field:'designFileName',
      width:160,
      autoHeight: true,
      wrapText: true,
      suppressSpanHeaderHeight: true,
      headerClass: 'hide-empty-header',
      cellStyle: this.pageVisitCellStyle,
      valueGetter: (params: any) => {
        return params.data?.designFileName ?? '';
      },
      cellRenderer: (params: any) => {
        return `
                <div>
                <span class="ofp-link">${params.data?.designFileName ?? ''}</span>
                </div>
              `;
      },
      onCellClicked: (event:any) => {
        this.downloadUploadedFile(event.data.activityId,event.data.designFileName);
      },
    },
    {
      headerName: 'Uploaded File Details Page',
      children: [

        {
          headerName: 'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.UploadFileDetailsPage?.pageVisited
        },

        {
          headerName: 'Issues Displayed',
          colId:'issuesDisplayed',
          width:130,
          cellRenderer: (params: any) => {
            const issuesDisplayedData = params.data?.pageContentAsMap?.UploadFileDetailsPage?.issuesDisplayed?.length;
            if(issuesDisplayedData == 0){
              return '';
            }
            return params.data?.pageContentAsMap?.UploadFileDetailsPage?.issuesDisplayed?.length
              ? '<span class="ofp-link">List of Uploaded File Issues</span>'
              : '';
          },
          onCellClicked: (params: any) => {
            const issuesDisplayedData = params.data?.pageContentAsMap?.UploadFileDetailsPage?.issuesDisplayed?.length;
            if(issuesDisplayedData == 0 || issuesDisplayedData == undefined){
              return '';
            }else{
              this.openUploadedFileIssues(this.uploadedFileIssuesTemplate,params.data.pageContentAsMap?.UploadFileDetailsPage?.issuesDisplayed);
            }
          }
        },

        {
          headerName: 'File Re-uploaded?',
          width:150,
          autoHeight: true,
          wrapText: true,
          suppressSpanHeaderHeight: true,
          headerClass: 'hide-empty-header',
          cellStyle: this.pageVisitCellStyle,
          valueGetter: (params: any) => {
            const page = params.data.pageContentAsMap?.UploadFileDetailsPage;
            if (!page?.fileReUploaded) {
              return '';
            }
            return `Yes\n${page.fileReUploaded}`;
          },
          cellRenderer: (params: any) => {
            const value = params.data.pageContentAsMap?.UploadFileDetailsPage?.fileReUploaded;
            if (!value) {
              return '';
            }
            return `
              <div style="line-height:1.1">
                <div><strong>Yes</strong></div>
                <div>${params.data.pageContentAsMap?.UploadFileDetailsPage?.fileReUploaded ?? ''}</div>
              </div>
            `;
          },    
        }
      ]
    },
    {
      headerName: 'Board Details Page',
      children: [
        {
          headerName: 'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.BoardDetailsPage?.pageVisited
        },
        {
          headerName: 'Initial PCB Specifications',
          colId:'initialSpecification',
          width:140,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          cellRenderer: (params: any) => {
            const initialPcbSpecificationsdata = params.data?.pageContentAsMap?.BoardDetailsPage?.initialPcbSpecifications;
            if(!initialPcbSpecificationsdata){
              return '';
            }
            return params.data?.pageContentAsMap?.BoardDetailsPage?.initialPcbSpecifications
              ? '<span class="ofp-link">List of Specification</span>'
              : '';
          },
          onCellClicked: (params: any) => {
            const initialPcbSpecificationsdata = params.data?.pageContentAsMap?.BoardDetailsPage?.initialPcbSpecifications;
            if(!initialPcbSpecificationsdata){
              return '';
            }
            this.openListOfSpecification(this.listOfSpecificationTemplate, params.data.pageContentAsMap?.BoardDetailsPage?.initialPcbSpecifications.Extracted, params.data.pageContentAsMap?.BoardDetailsPage?.initialPcbSpecifications.Default, params.data.pageContentAsMap?.BoardDetailsPage?.initialPcbSpecifications.Updated);
          }
        },
        {
          headerName: 'Final PCB Specifications',
          colId:'finalSpecification',
          width: 140,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          cellRenderer: (params: any) => {
            const finalPcbSpecificationsdata = params.data?.pageContentAsMap?.BoardDetailsPage?.finalPcbSpecifications;
            if(!finalPcbSpecificationsdata){
              return '';
            }
            return params.data?.pageContentAsMap?.BoardDetailsPage?.finalPcbSpecifications
              ? '<span class="ofp-link">List of Specification</span>'
              : '';
          },
          onCellClicked: (params: any) => {
            const finalPcbSpecificationsdata = params.data?.pageContentAsMap?.BoardDetailsPage?.finalPcbSpecifications;
            if(!finalPcbSpecificationsdata){
              return '';
            }
            this.openListOfSpecification(this.listOfSpecificationTemplate, params.data.pageContentAsMap?.BoardDetailsPage?.finalPcbSpecifications.Extracted, params.data.pageContentAsMap?.BoardDetailsPage?.finalPcbSpecifications.Default, params.data.pageContentAsMap?.BoardDetailsPage?.finalPcbSpecifications.Updated);
          }
        },
        {
          headerName: 'Custom Quote Specifications',
          colId:'customQuoteParams',
          width: 140,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          cellRenderer: (params: any) => {
            const customQuoteParamdata = params.data?.pageContentAsMap?.BoardDetailsPage?.customQuoteParam;
            if(!customQuoteParamdata){
              return '';
            }
            return params.data?.pageContentAsMap?.BoardDetailsPage?.customQuoteParam
              ? '<span class="ofp-link">List of Specification</span>'
              : '';
          },
          onCellClicked: (params: any) => {
            const customQuoteParamdata = params.data?.pageContentAsMap?.BoardDetailsPage?.customQuoteParam;
            if(!customQuoteParamdata){
              return '';
            }
            this.openListOfCustomSpecifications(this.listOfCustomSpecificationsTemplate,params.data.pageContentAsMap?.BoardDetailsPage?.customQuoteParam);
          }
        },
        {
          headerName:'Specifications Deviating from SSP',
          width: 140,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          cellRenderer: (params: any) => {
            const webPCBQuoteParametersdata = params.data?.pageContentAsMap?.BoardDetailsPage?.webPCBQuoteParameters;
            if(!webPCBQuoteParametersdata){
              return '';
            }
            return params.data?.pageContentAsMap?.BoardDetailsPage?.webPCBQuoteParameters
              ? '<span class="ofp-link">List of Specification</span>'
              : '';
          },
          onCellClicked: (params: any) => {
            const webPCBQuoteParametersdata = params.data?.pageContentAsMap?.BoardDetailsPage?.webPCBQuoteParameters;
            if(!webPCBQuoteParametersdata){
              return '';
            }
            this.openListOfCustomSpecifications(this.listOfCustomSpecificationsTemplate,params.data.pageContentAsMap?.BoardDetailsPage?.webPCBQuoteParameters);
          }
        },
        {
          headerName:'Returned to Uploaded File Details Page?',
          width: 140,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.BoardDetailsPage?.returnedToUploadFileDetailsPage
        },
        {
          headerName:'File Re-uploaded?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: (params: any) => {
            const page = params.data.pageContentAsMap?.BoardDetailsPage;
            if (!page?.fileReUploaded) {
              return '';
            }
            return `Yes\n${page.fileReUploaded}`;
          },
          cellRenderer: (params: any) => {
            const value = params.data.pageContentAsMap?.BoardDetailsPage?.fileReUploaded;
            if (!value) {
              return '';
            }
            return `
              <div style="line-height:1.1">
                <div><strong>Yes</strong></div>
                <div>${params.data.pageContentAsMap?.BoardDetailsPage?.fileReUploaded ?? ''}</div>
              </div>
            `;
          },  
        },
        {
          headerName:'Product Type',
          width: 150,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.BoardDetailsPage?.productType
        }
      ]
    },
    {
      headerName:'Confirm Custom Quote Request - Quote Details Page',
      children:[
        {
          headerName:'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.ConfirmQuoteQuoteDetailsPage?.pageVisited
        },
        {
          headerName:'Returned to Board Details Page?',
          width: 140,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.ConfirmQuoteQuoteDetailsPage?.returnedToBoardDetailsPage
        },
        {
          headerName: 'Custom Quote Specifications',
          colId:'leadFreecustomQuoteParams',
          width: 140,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: (params: any) => {
            const data = params.data?.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.leadFreeExtracteddata;
            if (!data) {
              return '';
            }
            return Object.entries(data)
              .map(([key, value]) => `${key}: ${value}`)
              .join('\n');
          }, 
          cellRenderer: (params: any) => {
            const customQuoteParamdata = params.data?.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.leadFreeExtracteddata;
            if(!customQuoteParamdata){
              return '';
            }
            return  `
              ${Object.entries(customQuoteParamdata)
                .map(([key, value]) => `
                  <span>${key}: ${value} <br/></span>
                `)
                .join('')}
            `;
          },
          onCellClicked: (params: any) => {
            const customQuoteParamdata = params.data?.pageContentAsMap?.BoardDetailsPage?.customQuoteParam;
            if(!customQuoteParamdata){
              return '';
            }
            this.openListOfCustomSpecifications(this.listOfCustomSpecificationsTemplate,params.data.pageContentAsMap?.BoardDetailsPage?.customQuoteParam);
          }
        },
        {
          headerName:'Assembly Added?',
          width: 140,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.ConfirmQuoteQuoteDetailsPage?.assemblyAdded
        },
        {
          headerName:'BOM File',
          width: 160,
          autoHeight: true,
          wrapText: true,
          suppressSpanHeaderHeight: true,
          headerClass: 'hide-empty-header',
          cellStyle: this.pageVisitCellStyle,
          valueGetter: (params: any) => {
            const bomName = params.data?.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName;
            if (!bomName) {
              return '';
            }
            const lines: string[] = [];
            if (bomName.fromDesignFile) {
              lines.push(`From design file: ${bomName.fromDesignFile}`);
            }
            if (bomName.added) {
              lines.push(`Added: ${bomName.added.split('|')[0]}`);
            }
            if (bomName.changed) {
              lines.push(`Updated: ${bomName.changed.split('|')[0]}`);
            }
            return lines.join('\n');
          },
          cellRenderer: (params: any) => {
            const fromDesignFileValue = params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName?.fromDesignFile;
            const bomAddedValue = params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName?.added;
            const bomChangedValue = params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName?.changed;
            let html='';
            if(fromDesignFileValue) {
              html += `
                <div style="line-height:1.3">
                  <span><strong>From design file: </strong></span><span>${params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName?.fromDesignFile ?? ''}</span>
                </div>
              `;
            }
            if(bomAddedValue){
               html += `
                <div style="line-height:1.3">
                  <span><strong>Added: </strong></span><span class="ofp-link">${params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName?.added.split('|')[0] ?? ''}</span>
                </div>
              `;
            }
            if(bomChangedValue) {
              html += `
                <div style="line-height:1.3">
                  <span><strong>Updated: </strong></span><span class="ofp-link">${params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName?.changed.split('|')[0] ?? ''}</span>
                </div>
              `;
            }
            return  html || '';
          },
          onCellClicked: (params: any) => {
            const bomAddedValue = params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName?.added;
            const bomChangedValue = params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName?.changed;
            if(bomAddedValue){
              this.downloadUploadedBomFile(params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName?.added.split('|')[1]);
            }
            if(bomChangedValue) {
             this.downloadUploadedBomFile(params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.BomName?.changed.split('|')[1]);
            }
            
          }
        },
        {
          headerName:'File Re-uploaded?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: (params: any) => {
            const page = params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage;
            if (!page?.fileReUploaded) {
              return '';
            }
            return `Yes\n${page.fileReUploaded}`;
          },
          cellRenderer: (params: any) => {
            const value = params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.fileReUploaded;
            if (!value) {
              return '';
            }
            return `
              <div style="line-height:1.1">
                <div><strong>Yes</strong></div>
                <div>${params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.fileReUploaded ?? ''}</div>
              </div>
            `;
          },
        },
        {
          headerName:'Quote Request Placed?',
           valueGetter: (params: any) => {
            const page =
              params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage;
            if (!page?.quoteRequestPlaced) {
              return '';
            }
            let value = '';
            if (page.rNumber) {
              value += `RNumber: ${page.rNumber}`;
            }
            if (page.spx) {
              if (value) {
                value += '\n';
              }
              value += `SPX: ${page.spx}`;
            }
            return value;
          },
          cellRenderer: (params: any) => {
            const value = params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.quoteRequestPlaced;
            if (!value) {
              return '';
            }
            return `
              <div style="line-height:1.3">
                ${params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.rNumber ? `<div><b>RNumber: </b> ${params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.rNumber ?? ''}</div>` : ''}
                ${params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.spx ? `<div><b>SPX: </b> ${params.data.pageContentAsMap?.ConfirmQuoteQuoteDetailsPage?.spx ?? ''}</div>` : ''}
              </div>
            `;
          },
        }
      ]
    },
    {
      headerName:'PCB Fabrication Pricing Page',
      children:[
        {
          headerName:'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.PCBFabPricingPage?.pageVisited
        },
        {
          headerName:'Returned to Board Details Page?',
          width: 140,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.PCBFabPricingPage?.returnedToBoardDetailsPage
        },
        {
          headerName:'Assembly Added?',
          width: 140,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.PCBFabPricingPage?.assemblyAdded
        },
        {
          headerName:'BOM File',
          width: 160,
          autoHeight: true,
          wrapText: true,
          suppressSpanHeaderHeight: true,
          headerClass: 'hide-empty-header',
          cellStyle: this.pageVisitCellStyle,
          valueGetter: (params: any) => {
            const bomName = params.data?.pageContentAsMap?.PCBFabPricingPage?.BomName;
            if (!bomName) {
              return '';
            }
            const lines: string[] = [];
            if (bomName.fromDesignFile) {
              lines.push(`From design file: ${bomName.fromDesignFile}`);
            }
            if (bomName.added) {
              lines.push(`Added: ${bomName.added.split('|')[0]}`);
            }
            if (bomName.changed) {
              lines.push(`Updated: ${bomName.changed.split('|')[0]}`);
            }
            return lines.join('\n');
          },
          cellRenderer: (params: any) => {
            const fromDesignFileValue = params.data.pageContentAsMap?.PCBFabPricingPage?.BomName?.fromDesignFile;
            const bomAddedValue = params.data.pageContentAsMap?.PCBFabPricingPage?.BomName?.added;
            const bomChangedValue = params.data.pageContentAsMap?.PCBFabPricingPage?.BomName?.changed;
            let html = '';
            if(fromDesignFileValue) {
               html += `
                <div style="line-height:1.3">
                  <span><strong>From design file: </strong></span><span>${params.data.pageContentAsMap?.PCBFabPricingPage?.BomName?.fromDesignFile ?? ''}</span>
                </div>
              `;
            }
            if(bomAddedValue){
               html += `
                <div style="line-height:1.3">
                  <span><strong>Added: </strong></span><span class="ofp-link">${params.data.pageContentAsMap?.PCBFabPricingPage?.BomName?.added.split('|')[0] ?? ''}</span>
                </div>
              `;
            }
            if(bomChangedValue) {
               html += `
                <div style="line-height:1.3">
                  <span><strong>Updated: </strong></span><span class="ofp-link">${params.data.pageContentAsMap?.PCBFabPricingPage?.BomName?.changed.split('|')[0] ?? ''}</span>
                </div>
              `;
            }
            return  html || '';
          },
          onCellClicked: (params: any) => {
            const bomAddedValue = params.data.pageContentAsMap?.PCBFabPricingPage?.BomName?.added;
            const bomChangedValue = params.data.pageContentAsMap?.PCBFabPricingPage?.BomName?.changed;
            if(bomAddedValue){
              this.downloadUploadedBomFile(params.data.pageContentAsMap?.PCBFabPricingPage?.BomName?.added.split('|')[1]);
            }
            if(bomChangedValue) {
             this.downloadUploadedBomFile(params.data.pageContentAsMap?.PCBFabPricingPage?.BomName?.changed.split('|')[1]);
            }
            
          },
        }
      ]
    },
    {
      headerName:'BOM Column Mapping Page',
      children:[
        {
          headerName:'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.BOMColumnPage?.pageVisited
        },
        {
          headerName:'Column Mapping Changed?',
          autoHeight: true,
          wrapText: true,
          suppressSpanHeaderHeight: true,
          headerClass: 'hide-empty-header',
          cellStyle: this.pageVisitCellStyle,
          valueGetter: (params: any) => {
            const obj = params.data?.pageContentAsMap?.BOMColumnPage?.mapping;
            if (!obj) {
              return '';
            }
            const lines = Object.entries(obj).map(
              ([key, value]) => `${key}: ${value}`
            );
            return [
              'Column Name In UI : Mapped Name from BOM',
              ...lines
            ].join('\n');
          },
          cellRenderer: (params: any) => {
            const obj = params.data?.pageContentAsMap.BOMColumnPage?.mapping;
            if (!obj) {
              return '';
            }
            return  `
              <div class="fw-b" >
                Column Name In UI : Mapped Name from BOM
              </div>
              ${Object.entries(obj)
                .map(([key, value]) => `
                  <span>${key}: ${value} <br/></span>
                `)
                .join('')}
            `;
          }
        },
      ]
    },
    {
      headerName:'BOM Pre-processor Page',
      children:[
        {
          headerName:'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.BOMPreProcessorPage?.pageVisited
        },
        {
          headerName:'BOM Changed?',
          valueGetter: (params: any) => {
            const value = params.data?.pageContentAsMap?.BOMPreProcessorPage?.bomName;
            if (!value) {
              return '';
            }
            return value.split('|')[0];
          },
          cellRenderer: (params: any) => {
            const value = params.data.pageContentAsMap?.BOMPreProcessorPage?.bomName;
            if (!value) {
              return '';
            }
            return `
                    <div>
                      <span class="ofp-link">${params.data?.pageContentAsMap.BOMPreProcessorPage?.bomName.split('|')[0] ?? ''}</span>
                    </div>
                  `;
          },
          onCellClicked: (event:any) => {
            this.downloadUploadedBomFile(event.data.pageContentAsMap.BOMPreProcessorPage?.bomName.split('|')[1]);
          },
        }
      ]
    },
    {
      headerName:'Component Procurement Page',
      children:[
        {
          headerName:'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.ComponentProcurementPage?.pageVisited
        },
        {
          headerName:'Line Item Count',
          valueGetter: (params: any) => {
            const lineItemCount = params.data?.pageContentAsMap?.ComponentProcurementPage?.lineItemCount;
            if (!lineItemCount) {
              return '';
            }
            const lines: string[] = [];
            if (lineItemCount.okayToBuy) {
              lines.push(`Okay to Buy: ${lineItemCount.okayToBuy}`);
            }
            if (lineItemCount.dni) {
              lines.push(`DNI: ${lineItemCount.dni}`);
            }
            if (lineItemCount.customerSupport) {
              lines.push(`Customer Support: ${lineItemCount.customerSupport}`);
            }
            if (lineItemCount.consigned) {
              lines.push(`Consiged: ${lineItemCount.consigned}`);
            }
            if (lineItemCount.issues) {
              lines.push(`Issues: ${lineItemCount.issues}`);
            }
            return lines.join('\n');
          },

          cellRenderer: (params: any) => {
            const okayToBuy = params.data.pageContentAsMap?.ComponentProcurementPage?.lineItemCount?.okayToBuy;
            const dni = params.data.pageContentAsMap?.ComponentProcurementPage?.lineItemCount?.dni;
            const customerSupport = params.data.pageContentAsMap?.ComponentProcurementPage?.lineItemCount?.customerSupport;
            const consigned = params.data.pageContentAsMap?.ComponentProcurementPage?.lineItemCount?.consigned;
            const issues = params.data.pageContentAsMap?.ComponentProcurementPage?.lineItemCount?.issues;
            let cppHtml = '';
            if(okayToBuy){
              cppHtml += `
              <div><b>Okay to Buy: </b> ${okayToBuy}</div>
              `;
            }
            if(dni){
              cppHtml += `
                <div><b>DNI: </b> ${dni }</div>
              `;
            }
            if(customerSupport){
              cppHtml += `
                <div ><b>Customer Support: </b>  ${customerSupport}</div>
              `;
            }
            if(consigned){
              cppHtml += `
                <div><b>Consiged: </b> ${consigned}</div>
              `;
            }
            if(issues){
              cppHtml += `
                <div><b>Issues: </b> ${issues}</div>
              `;
            }
            return cppHtml || '';
            
            
          }
        }
      ]
    },
    {
      headerName:'Assembly Labor Pricing Page',
      children:[
        {
          headerName:'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.AssemblyLabourPricingPage?.pageVisited
        }
      ]
    },
    {
      headerName:'Confirm Quote Request Page',
      children:[
        {
          headerName:'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.ConfirmQuoteRequestPage?.pageVisited
        },
        {
          headerName:'Quote Saved?',
          colId: 'quoteSaved',
          valueGetter: (params: any) => {
          const page = params.data.pageContentAsMap?.ConfirmQuoteRequestPage;
          if (!page?.quoteSaved) {
            return '';
          }
          let value = page.quoteSaved;
          if (page.quoteId) {
            value += `\nQuote ID: ${page.quoteId}`;
          }
          if (page.spx) {
            value += `\nSPX: ${page.spx}`;
          }
          return value;
        },
          cellRenderer: (params: any) => {
            const value = params.data.pageContentAsMap?.ConfirmQuoteRequestPage?.quoteSaved;
            if (!value) {
              return '';
            }
            return `
              <div style="line-height:1.3">
                <div>${value}</div>
                ${params.data.pageContentAsMap?.ConfirmQuoteRequestPage?.quoteId ? `<div><b>Quote ID: </b> ${params.data.pageContentAsMap?.ConfirmQuoteRequestPage?.quoteId ?? ''}</div>` : ''}
                ${params.data.pageContentAsMap?.ConfirmQuoteRequestPage?.spx ? `<div><b>SPX: </b> ${params.data.pageContentAsMap?.ConfirmQuoteRequestPage?.spx ?? ''}</div>` : ''}
              </div>
            `;
          }

        },
        {
          headerName:'Place Order Initiated?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.ConfirmQuoteRequestPage?.placeOrderInitiated
        },
        {
          headerName:'File Re-uploaded?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: (params: any) => {
            const page = params.data.pageContentAsMap?.ConfirmQuoteRequestPage;
            if (!page?.fileReUploaded) {
              return '';
            }
            return `Yes\n${page.fileReUploaded}`;
          },
          cellRenderer: (params: any) => {
            const value = params.data.pageContentAsMap?.ConfirmQuoteRequestPage?.fileReUploaded;
            if (!value) {
              return '';
            }
            return `
              <div style="line-height:1.3">
                <div><strong>Yes</strong></div>
                <div>${params.data.pageContentAsMap?.ConfirmQuoteRequestPage?.fileReUploaded ?? ''}</div>
              </div>
            `;
          },  
        },
        {
          headerName:'Re-quoted?',
           valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.ConfirmQuoteRequestPage?.reQuoted
        },
        {
          headerName:'Returned to CP Page?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
           valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.ConfirmQuoteRequestPage?.reQureturnedToCPPageoted
        }
      ]
    },
    {
      headerName:'Sign-in / Registration Page?',
      children:[
        {
          headerName:'Navigated to Sign-in / Registration Page?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.SignInRegistrationPage?.navigatedTo
        },
        {
          headerName:'Sign-in / Registration Successful?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.SignInRegistrationPage?.signIn
        }
      ]
      // width: 135,
      // autoHeight: true,
      // wrapText: true,
      // cellStyle: this.pageVisitCellStyle,
      // suppressSpanHeaderHeight: true,
      // headerClass: 'hide-empty-header',
      // valueGetter: ({ data }: { data: any }) =>
      //     data?.pageContentAsMap.SignInRegistrationPage?.signIn
    },
    {
      headerName:'Additional Component Details Page',
      children:[
        {
          headerName:'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.AdditionalComponentDetailsPage?.pageVisited
        }
      ]
    },
    {
      headerName:'Order Details Page',
      children:[
        {
          headerName:'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.OrderDetailsPage?.pageVisited
        }
      ]
    },
    {
      headerName:'Review & Confirm Page',
      children:[
        {
          headerName:'Page Visited?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: ({ data }: { data: any }) =>
            data?.pageContentAsMap.ReviewConfirmOrderPage?.pageVisited
        },
        {
          headerName:'Order Placed?',
          width: 135,
          autoHeight: true,
          wrapText: true,
          cellStyle: this.pageVisitCellStyle,
          valueGetter: (params: any) => {
            const orderId = params.data?.pageContentAsMap?.ReviewConfirmOrderPage?.orderId;
            if (!orderId) {
              return '';
            }
            return `Order ID: ${orderId}`;
          },
          cellRenderer: (params: any) => {
            const value = params.data.pageContentAsMap?.ReviewConfirmOrderPage?.orderId;
            if (!value) {
              return '';
            }
            return `
              <div style="line-height:1.3">
                <div><b>Order ID: </b> ${params.data.pageContentAsMap?.ReviewConfirmOrderPage?.orderId ?? ''}
              </div>
            `;
          }
        }
      ]
    },
    {
      headerName:'Total time spent',
      suppressSpanHeaderHeight: true,
      width: 170,
      autoHeight: true,
      wrapText: true,
      cellStyle: this.pageVisitCellStyle,
      headerClass: 'hide-empty-header',
      valueGetter: ({ data }: { data: any }) =>
            data?.totalTimeSpent
    }
  ];
  }

  openUploadedFileIssues(content:any,issueDatas:any){
    this.issuesList = issueDatas;
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"});
   
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  
  updatePagination(){
    this.totalPages = Math.ceil(this.dashBoardArray.length / this.itemsPerPage);
    this.paginateTable();
    setTimeout(() => this.setupPagination(), 0); 
  }

  paginateTable(){
    var startIndex = (this.currentPage - 1) * this.itemsPerPage;
    this.paginatedItems = this.dashBoardArray.slice(startIndex, startIndex + this.itemsPerPage);
    //commenting below to remove pagination logic from backend- OFP-1948
    // var startIndex = ((this.currentPage -1)*15)+1;
    // this.paginatedItems = this.dashBoardArray;
    
  }

  setupPagination(){
    $('#pagination').empty();
    var startPage;
    var endPage;

    if(this.totalPages <= this.maxVisiblePages) {
      startPage = 1;
      endPage = this.totalPages;
    }else {
      if (this.currentPage <= 5) {
        startPage = 1;
        endPage = 10;
      } else if (this.currentPage >= this.totalPages - 4) {
        startPage = this.totalPages - 9;
        endPage = this.totalPages;
      } else {
        startPage = this.currentPage - 4;
        endPage = this.currentPage + 5;
      }
    }
    if (this.currentPage > 1) {
      $('#pagination').append(`<a href="#" class="page-link prev" data-page="${this.currentPage - 1}">Previous</a>`);
    }
    for (let i = startPage; i <= endPage; i++) {
      $('#pagination').append(
        `<a href="#" class="page-link ${i === this.currentPage ? 'active' : ''}" data-page="${i}">${i}</a>`
      );
    }
    if (this.currentPage < this.totalPages) {
      $('#pagination').append(`<a href="#" class="page-link next" data-page="${this.currentPage + 1}">Next</a>`);
      //commenting below to remove pagination logic from backend- OFP-1948
      // $('#pagination').append(`<a href="#" class="page-link next" data-page="${this.currentPage + 1}" (click)="nextPage($event)">Next</a>`);
    } 
    $('.page-link').on('click', (event) => {
      event.preventDefault();
      this.currentPage = parseInt($(event.currentTarget).attr('data-page')!, 10);
      // if(this.selectFilterOption == 'emailId' || this.selectFilterOption == 'productType' || this.selectFilterOption == 'date'){
      //   this.searchForData(this.currentPage);
      // }else{
      //   this.callTogetAdminDashboardDatas('','','',this.currentPage,'');
      // }
      
      // setTimeout(() => {
        this.paginateTable();
        this.setupPagination();
      // }, 3000);
    });
  }

  downloadBomFile(){
    var downLoadUrl = this.apiService.scaBOMFileDownloadUrl+this.commonService.commonMainObj.finalBomDataToPurchase.bomId
    downLoadUrl = this.commonService.commonMainObj.userId?downLoadUrl+ '&userId=' +this.commonService.commonMainObj.userId:downLoadUrl+ '&emailId=' +this.commonService.commonMainObj.defaultEmail;
    window.open(downLoadUrl,'_self');
  }

  productTypeClick(event:any){

  }
  downloadUploadedFile(activityId:any,fileName:any){
    var downloadUrl= this.apiService.autoBOMFileDownloadUrl+"customer_"+activityId+".zip&expectedFileName="+fileName;
    this.apiService.downloadZipFile(activityId,fileName).subscribe((data: any)=>{
      if(data){
       window.open(downloadUrl,'_self');
      }
      },error =>{  
       if(error.status == 404){
        this.commonService.alertCall("Alert!", 'Selected file is archived and not available for download');
      }
    })
  }
  downloadUploadedBomFile(bomFileId:any){
    var downloadUrl= this.apiService.autoBOMFileDownloadUrl+bomFileId+'&isBom=True';
    this.apiService.downloadBomFile(bomFileId).subscribe((data: any)=>{
      if(data){
       window.open(downloadUrl,'_self');
      }
      },error =>{  
       if(error.status == 404){
        this.commonService.alertCall("Alert!", 'File Not Found');
      }
    })
  }
  exportCsv(): void {
    this.gridApi.exportDataAsCsv({
      fileName: `${this.exportFileName}.csv`,
      processCellCallback: (params: any) => {

        if (params.column.getColId() === 'issuesDisplayed') {
          const issues = params.node.data.pageContentAsMap?.UploadFileDetailsPage?.issuesDisplayed;
          if (!issues?.length) {
            return '';
          }
          const issueList = issues.map((item: any) => {
            const values: string[] = [];
            if (item?.error) {
              values.push(item.error);
            }
            if (item?.warning) {
              values.push(item.warning);
            }
            return values.join(' , ');
          }).filter(Boolean).join(', ');
          return `List of Uploaded File Issues: ${issueList}`;
        }
        if(params.column.getColId() === 'customQuoteParams'){
          const customParams = params.node.data.pageContentAsMap?.BoardDetailsPage?.customQuoteParam;
          if (!customParams) {
            return '';
          }
          const values = Object.values(customParams).filter(value => value != null).join(' , ');
          return `List of Specification : ${values}`;
        }  
        if(params.column.getColId() === 'webQuoteParams'){
          const webParams = params.node.data.pageContentAsMap?.BoardDetailsPage?.webPCBQuoteParameters;
          if (!webParams) {
            return '';
          }
          const values = Object.values(webParams).filter(value => value != null).join(' , ');
          return `List of Specification : ${values}`;
        } 
        if(params.column.getColId() === 'initialSpecification'){
          const data = params.node.data.pageContentAsMap?.BoardDetailsPage?.initialPcbSpecifications;
          if (!data) {
            return '';
          }

          return Object.entries(data)
            .map(([section, items]: [string, any]) => {
              const values = items
                .map((item: any) => `${item.key}: ${item.value}`)
                .join(' , ');
              return `${section}:- ${values}`;
            })
        }  
        if(params.column.getColId() === 'finalSpecification'){
          const data = params.node.data.pageContentAsMap?.BoardDetailsPage?.finalPcbSpecifications;
          if (!data) {
            return '';
          }

          return Object.entries(data)
            .map(([section, items]: [string, any]) => {
              const values = items
                .map((item: any) => `${item.key}: ${item.value}`)
                .join(' , ');

              return `${section}:- ${values}`;
            })
        }      
        return params.value;
      }
    });
  }



}
